import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from '../../../../../../components/CustomSelect/Select';
import {useSelector} from 'react-redux';
import Loading from '../../../../../../components/loading';
import SpecialBookingForm from './SpecialBookingForm';
import styles from './addspecialbooking.module.css';

function AddSpecialBooking(props) {
    const { handleShowGuest, guestData } = props;
    const guestList= useSelector(({guests})=>guests && guests.guestList);
    const rentalList = useSelector(({rentals})=>rentals && rentals.rentals);
    const [selectedGuest, setSelectedGuest] = useState(guestData ?
        ( (guest) => ({ label: guest?.name, value: guest?.id }) )(guestData) : ""
    );
    const [guestError, setGuestError] = useState("");
    const actionForAddGuest = useSelector(({ guests }) => guests && guests.actionForAddGuest);

    const compare = (a, b) => {
        return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
    }

    const handleGuestChange = (val) => {
        if(val !== "") {
            setGuestError("");
        }
        setSelectedGuest(val);
    }

    return (
        <>
            <Loading loadingStatus={actionForAddGuest.loading}/>
            <Modal.Header closeButton>
                <Modal.Title  className={styles.modalTitle}>Add fixed-term booking</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-2">
                    <br />
                    <h3 className={styles.header}>Guest Details</h3>
                    <div className={styles.searchGuest}>
                        <Select
                            options={guestList.map((row)=>({label:row.name,value:row.id})).sort(compare)}
                            onChange={handleGuestChange}
                            value={selectedGuest}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={"Search guest..."}
                            onError={!!guestError}
                        />
                        <div className={styles.form_error}>
                            {guestError}
                        </div>
                    </div>
                    <button type="submit" className={`${styles.addBtn} ${styles.greyBtn}`} onClick={handleShowGuest}>
                        Add Guest
                    </button>
                </div>
                <div>
                    <h3 className={styles.header}>Booking Details</h3>
                    <SpecialBookingForm
                        addSpecialBookingFromEmptyNight={props.addSpecialBookingFromEmptyNight}
                        guestDetail={selectedGuest}
                        rentals={rentalList}
                        handleGuestError={setGuestError}
                        onHide={props.onHide}
                        handleSave={(data,guestData,check) => props.handleSave(data,guestData,check)}
                    />
                </div>
            </Modal.Body>
        </>
    )
}

export default AddSpecialBooking;